import { createSelector } from '@reduxjs/toolkit';

export const selectMap = createSelector((store: any) => store, store => store.map);
